var map = {
	"./404.png": "zAji",
	"./activity.png": "Nkfs",
	"./background.png": "cf+J",
	"./countdown/countdown-background.png": "hsbP",
	"./logo.png": "7Otq",
	"./quiz-background.png": "W1Kw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UY1V";


//////////////////
// WEBPACK FOOTER
// ./src/assets \.(png|jpeg|jpg|gif)$
// module id = UY1V
// module chunks = 1